import { Component } from '@angular/core';
import { RouterModule } from "@angular/router";
import { ToastModule } from 'primeng/toast';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { SharedModule } from "../shared/shared-module";

@Component({
  selector: 'app-root',
  templateUrl: './addin-root.component.html',
  styleUrls: ['./addin-root.component.css'],
  imports: [RouterModule, ToastModule, ProgressSpinnerModule, SharedModule]
})
export class AddinRootComponent {
  title = 'YMS Add-in';
  loading = false;
}
